<template>
  <div class="xz_multipleSelect">
    <div class="xz_selectOptions">
      <span
        class="xz_option_item"
        :class="{'xz_selectedActive': option.check}"
        v-for="(option, index) in optionsList"
        :key="index"
        @click="selectItem(index)"
      >{{option.value}}</span>
    </div>
    <!--自定义-->
    <div class="xz_addTag" v-if="custom">
      <input
        type="text"
        class="xz_addTag_input"
        :class="{'error_alert': showWarn}"
        v-model.trim="customText"
        @input="showWarn=false"
      />
      <button type="button" class="xz_addTag_btn" @click="customTag">{{customlabel}}</button>
    </div>
    <p class="warnText_style" v-if="showWarn">{{warnText}}</p>
    <div class="xz_selectedOption" v-if="optionItems.length > 0">
      <span class="xz_selected_item" v-for="(item, index) in optionItems" :key="index">
        <i class="xz_delSelected" @click="delItems(item)"></i>
        {{item}}
      </span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    options: {
      type: Object,
      default: function () {
        return [];
      },
    },
    selected: {
      type: Object,
      default: function () {
        return [];
      },
    },
    custom: {
      type: Boolean,
      default: false,
    },
    customlabel: {
      type: String,
      default: "新增福利",
    },
  },
  data() {
    return {
      // 选择项
      optionsList: [],
      // 已选择项
      optionItems: [],
      // 自定义填写
      customText: "",
      // 警告语句
      warnText: "填写内容已存在",
      // 显示警告语句
      showWarn: false,
    };
  },
  mounted() {
    this.optionsList = this.options;
  },
  watch: {
    // 设置已选择项
    selected: {
      handler: function () {
        if (this.selected) {
         
          this.optionItems = this.selected;
          //  console.log('opt',this.optionItems)
          const options = this.optionsList;
          this.selected.forEach((opt) => {
            let i = 0;
            for (; i < options.length; i++) {
              if (opt === options[i].value) {
                options[i].check = true;
                break;
              }
            }
          });
          //
          this.optionsList = options;
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 新增标签
    customTag() {
      // 判断是否存在
      let isExist = false;
      const val = this.customText.trim();
      const options = this.optionsList;
      const items = this.optionItems;
      if (!val) return;

      //判断值是否存在于已选择项
      let i = 0;
      for (; i < items.length; i++) {
        // 已存在值
        if (items[i] === val) {
          this.showWarn = true;
          isExist = true;
        }
      }
      if (isExist) return;
      let a = 0;
      for (; a < options.length; a++) {
        if (options[a].value === val && options[a].check === false) {
          this.customText = "";
          this.showWarn = false;
          this.isExist = true;
          this.selectItem(a, false);
        }
      }
      // 如果不存在于选项中和被选项中
      if (!isExist) {
        items.push(val);
        this.optionItems = items;
        this.customText = "";
        this.showWarn = false;
        // 返回数据
        this.$emit("change", this.optionItems);
      }
    },
    // 移除选择项
    delItems(item) {
      const items = this.optionItems;
      let i = 0;
      for (; i < items.length; i++) {
        if (items[i] === item) {
          items.splice(i, 1);
          this.optionItems = items;
          break;
        }
      }
      // 清除选中样式
      const options = this.optionsList;
      let a = 0;
      for (; a < options.length; a++) {
        if (options[a].value === item) {
          options[a].check = false;
          this.optionsList = options;
          break;
        }
      }

      // 返回数据
      this.$emit("change", this.optionItems);
    },
    // 选择标签
    selectItem(i, check = true) {
      const val = this.optionsList[i];
      const selected = this.optionItems;
      if (check) {
        if (val.check) {
          let i = 0;
          selected.forEach((s, index) => {
            if (s === val.value) i = index;
          });
          selected.splice(i, 1);
        } else {
          selected.push(val.value);
        }
        this.optionItems = selected;
        val.check = val.check ? false : true;
      } else {
        val.check = true;
        selected.push(val.value);
        this.optionItems = selected;
      }

      // 返回数据
      this.$emit("change", this.optionItems);
    },
  },
};
</script>
<style scoped>
.xz_multipleSelect {
  width: 550px;
}
.xz_selectOptions {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.xz_option_item {
  border: 1px solid #ddd;
  border-radius: 5px;
  cursor: pointer;
  display: inline-block;
  margin: 0 8px 8px 0;
  color: #333;
  font-size: 14px;
  padding: 3px 17px;
}
.xz_delSelected {
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: 5px;
  display: block;
  width: 18px;
  height: 18px;
  background: url("../../assets/images/delete.png") no-repeat;
  background-size: 100% auto;
}
.xz_selected_item {
  display: block;
  margin: 0 8px 8px 0;
  color: #fff !important;
  border-radius: 5px;
  background: #409eff;
  padding: 4px 25px 4px 17px;
  position: relative;
  white-space: nowrap;
}
.xz_multipleSelect .xz_selectedActive {
  color: #fff !important;
  background: #409eff !important;
  border: 1px solid #409eff !important;
}
.xz_addTag {
  width: 100%;
  display: flex;
  align-items: center;
}
.xz_selectedOption {
  margin-top: 10px;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
}
.xz_addTag_input {
  width: 200px;
  border: 1px solid #ddd;
  border-radius: 6px;
  height: 40px;
  font-size: 14px;
  padding: 0 15px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: none;
  margin-right: 10px;
}
.xz_addTag_btn {
  border: 1px solid #ddd;
  border-radius: 5px;
  cursor: pointer;
  height: 40px;
  display: inline-block;
  color: #333;
  font-size: 14px;
  padding: 0 17px;
  outline: none;
}
.xz_addTag_btn:hover {
  border: 1px solid #409eff;
  background: #409eff;
  color: #fff;
}
.warnText_style {
  font-size: 14px;
  color: #c82a2e;
}
</style>